import { IDatasource } from "./IDatasource";
import { IParam } from "./IParam";

export const viewType:string = "ai_view"
export const botType:string = "ai_bot"
export const botPrecompiledType:string = "ai_bot_precompiled"


export interface IBot {
    id?:string
    type:string;
    parent_id: string;
    version: number;

    name?:string
    code?: string; // kod
    prompt: string
    prompt_params?:string[]
    data_source?:string
    
    use: IBot[]

    hidden?: boolean
    expanded?: boolean
    x?:number
    y?:number
    funct?: Function


    function_name: string; // nazwa
    function_desc: string; // opis
    function_call: string; // wywołanie
    function_code: string; // kod funkcji
    inputs: {[key: string]: IParam };  // wejścia
    outputs: {[key: string]: IParam }; // wyjścia

}